import { useMediaQuery } from '@mui/material';
import React from 'react';
import { Drawer } from 'src/components/shared/Drawer';
import { OfflineDriveCandidate } from 'types';
import VerifyDocumentsForm from './VerifyDocumentsForm';

const VerifyDocumentsDrawer = ({
	driveId,
	candidate,
	openVerifyDocumentsDrawer,
	setOpenVerifyDocumentsDrawer,
}: {
	driveId: string;
	candidate: OfflineDriveCandidate;
	openVerifyDocumentsDrawer: boolean;
	setOpenVerifyDocumentsDrawer: (open: boolean) => void;
}) => {
	const isMobile = useMediaQuery('(max-width: 960px)');

	const handleClose = () => {
		setOpenVerifyDocumentsDrawer(false);
	};
	return (
		<div>
			<Drawer
				fullWidth
				isModal={!isMobile}
				isOpen={openVerifyDocumentsDrawer}
				onClose={handleClose}
				maxHeight="80vh"
				minHeight="40vh"
				boxShadow="0px -8px 32px 0px #00000040"
				header={
					<div className="flex flex-col gap-2.5 pt-5 px-3">
						<h1 className="text-[#1F3343] text-lg font-medium leading-[140%] mb-2">
							Verify Documents for <span className="font-bold">{candidate.name}</span>
						</h1>
						<div className="w-full h-[1.3px] flex-shrink-0 rounded bg-gray-200" />
					</div>
				}
				body={
					<div className="py-4 px-3">
						<VerifyDocumentsForm driveId={driveId} candidateId={candidate._id} documentsData={candidate.documents} />
					</div>
				}
			/>
		</div>
	);
};

export default VerifyDocumentsDrawer;
